export default "__VITE_ASSET__1bcb860c__"